import { Button, Label, Modal } from 'flowbite-react'
import { useState } from 'react';

interface ICobrowseAtivarModalProps {
  onClose: () => void
  isOpen: boolean
}

const InitializeCobrowse = () => (function (g, e, n, es, ys) {
  g['_genesysJs'] = e;
  g[e] = g[e] || function () {
    (g[e].q = g[e].q || []).push(arguments)
  };
  g[e].t = 1 * new Date().getDate();
  g[e].c = es;
  ys = document.createElement('script');
  ys.async = 1;
  ys.src = n;
  ys.charset = 'utf-8';
  document.head.appendChild(ys);
})(window, 'Genesys', 'https://apps.usw2.pure.cloud/genesys-bootstrap/genesys.min.js', {
  environment: 'prod-usw2',
  deploymentId: 'b9cb2cb3-ee30-42a9-89eb-7532d7db4111'
})


const CobrowseAtivarModal: React.FC<ICobrowseAtivarModalProps> = ({
  onClose,
  isOpen
}: ICobrowseAtivarModalProps) => {
  const [isDisabled, setIsDisabled] = useState<boolean>(false)
  const SetCobrowse = () => {
    try {
      setIsDisabled(true);
      InitializeCobrowse();
      setTimeout(() => { onClose() }, 2000);
    }
    catch (error) {
      alert("Ocorreu um erro ao ativar o suporte com navegação compartilhada. Por favor, tente novamente.");
    }
  }
  return (
    <>
      <Modal
        show={isOpen}
        onClose={onClose}
        className='flex items-center'
        size='lg'
      >
        <Modal.Body>
          <div className='mb-5 text-left gap-2 flex flex-col'>
            <h3 className='p-2 text text-gray-900 font-semibold text-center'>
              Suporte com navegação compartilhada
            </h3>
            <Label className='p-2 text-left text-gray-900 text-sm'>
              Ao ativar essa opção, nosso time de atendimento
              poderá visualizar a sua navegação no Portal VR
              para ajudar você de forma mais rápida e eficiente.
              <br />
            </Label>
            <Label className='p-2 text-left text-gray-900 text-sm'>
              Essa visualização é temporária e segura.
              Só será iniciada com o seu consentimento e poderá ser interrompida a qualquer momento.
              <br />
            </Label>
            <Label className='p-2 text-left text-gray-900 text-sm'>
              Nenhuma informação fora do Portal VR será acessada.
            </Label>
          </div>
          <div className='w-full flex justify-between'>
            <div className='flex justify-between items-left'>
              <Button color='gray' onClick={onClose} data-testid='btn-close'>
                Fechar
              </Button>
            </div>
            <div className='flex justify-between items-right'>
              <Button color='success' onClick={() => SetCobrowse()} data-testid='btn-ativar' className='bg-quaternary' disabled={isDisabled}>
                Ativar
              </Button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  )
}

export default CobrowseAtivarModal
